export const ADD_WARRANTY_PARTNERS_SUCCESS  = "warranty/ADD_WARRANTY_PARTNERS_SUCCESS";
export const ADD_WARRANTY_PARTNERS_FAILURE  = "warranty/ADD_WARRANTY_PARTNERS_FAILURE";
export const ALL_WARRANTY_PARTNERS_SUCCESS  = "warranty/ALL_WARRANTY_PARTNERS_SUCCESS";
export const ALL_WARRANTY_PARTNERS_FAILURE  = "warranty/ALL_WARRANTY_PARTNERS_FAILURE";
